// Mock data for the UPS website

export const mockData = {
  // Hero section data
  hero: {
    title: "Acreditación Internacional de Universidades e Instituciones Promotoras de la Salud",
    subtitle:
      "Transformando la educación superior a través del bienestar y la salud integral",
    description:
      "Únete al movimiento global de instituciones comprometidas con la promoción de la salud y el bienestar en el ámbito universitario.",
    ctaButtons: [
      { text: "Iniciar Acreditación", href: "/acreditacion", primary: true },
      { text: "Conocer el Modelo", href: "/pilares", primary: false },
    ],
  },

  // Three pillars of the model
  pillars: [
    {
      id: 1,
      title: "Educación para la Salud y Habilidades para la Vida",
      description:
        "Desarrollo de competencias psicosociales esenciales para el bienestar integral",
      icon: "GraduationCap",
      details: [
        "Toma de decisiones informadas",
        "Pensamiento crítico y creativo",
        "Comunicación efectiva",
        "Empatía y relaciones interpersonales",
        "Manejo emocional y del estrés",
      ],
    },
    {
      id: 2,
      title: "Entornos Saludables",
      description:
        "Creación de espacios universitarios seguros, sostenibles y participativos",
      icon: "Building2",
      details: [
        "Campus seguros y accesibles",
        "Espacios verdes y sostenibles",
        "Ambiente participativo e inclusivo",
        "Bienestar estudiantil integral",
        "Clima organizacional positivo",
      ],
    },
    {
      id: 3,
      title: "Servicios, Nutrición y Vida Activa",
      description:
        "Promoción de estilos de vida saludables y acceso a servicios de calidad",
      icon: "Heart",
      details: [
        "Servicios médicos accesibles",
        "Programas de alimentación saludable",
        "Actividad física para toda la comunidad",
        "Prevención y promoción de la salud",
        "Bienestar físico y mental",
      ],
    },
    {
      id: 4,
      title: "Políticas Públicas Saludables",
      description:
        "Desarrollo de marcos normativos y participación en la agenda pública de salud",
      icon: "Scale",
      details: [
        "Marco normativo institucional",
        "Participación en agenda pública",
        "Incidencia en políticas globales",
        "Gobernanza universitaria",
        "Financiamiento sostenible",
      ],
    },
  ],

  // Accreditation process stages
  accreditationStages: [
    {
      id: 1,
      title: "Planeación y Registro",
      description: "Preparación institucional y registro en el sistema SIEVAS",
      icon: "FileText",
      duration: "2-3 meses",
    },
    {
      id: 2,
      title: "Autoevaluación",
      description: "Evaluación interna basada en los 100 ítems del modelo",
      icon: "Search",
      duration: "4-6 meses",
    },
    {
      id: 3,
      title: "Evaluación Externa",
      description: "Visita y evaluación por parte de expertos externos",
      icon: "Users",
      duration: "1-2 meses",
    },
    {
      id: 4,
      title: "Dictamen de Resultados",
      description: "Análisis y comunicación de resultados de la evaluación",
      icon: "Award",
      duration: "1 mes",
    },
    {
      id: 5,
      title: "Mejora Continua",
      description: "Implementación de planes de mejoramiento continuo",
      icon: "TrendingUp",
      duration: "Permanente",
    },
  ],

  // Achievement levels
  achievementLevels: [
    {
      level: "En Desarrollo",
      description: "Instituciones iniciando su proceso de transformación",
      color: "bg-yellow-100 text-yellow-800",
      percentage: "0-40%",
    },
    {
      level: "Acreditación Inicial",
      description: "Cumplimiento básico de estándares establecidos",
      color: "bg-blue-100 text-blue-800",
      percentage: "41-60%",
    },
    {
      level: "Avanzada",
      description: "Alto nivel de implementación y resultados",
      color: "bg-green-100 text-green-800",
      percentage: "61-80%",
    },
    {
      level: "Excelencia",
      description: "Liderazgo e innovación en promoción de la salud",
      color: "bg-purple-100 text-purple-800",
      percentage: "81-100%",
    },
  ],

  // Resources
  resources: [
    {
      id: 1,
      title: "Guía de Autoevaluación",
      description: "Manual completo para comités internos de evaluación",
      type: "PDF",
      category: "Guías",
      downloadUrl: "#",
    },
    {
      id: 2,
      title: "Manual del Evaluador Externo",
      description: "Protocolo para equipos de evaluación externa",
      type: "PDF",
      category: "Manuales",
      downloadUrl: "#",
    },
    {
      id: 3,
      title: "Matriz de Evidencias",
      description: "Instrumento para organización de evidencias",
      type: "Excel",
      category: "Instrumentos",
      downloadUrl: "#",
    },
    {
      id: 4,
      title: "Rúbricas de Evaluación",
      description: "Criterios detallados para cada indicador",
      type: "PDF",
      category: "Instrumentos",
      downloadUrl: "#",
    },
    {
      id: 5,
      title: "Infografía del Modelo UPS",
      description: "Representación visual del modelo completo",
      type: "PNG",
      category: "Infografías",
      downloadUrl: "#",
    },
  ],

  // News and events
  news: [
    {
      id: 1,
      title: "Convocatoria 2025: Nuevo Proceso de Acreditación",
      excerpt:
        "Se abre el registro para universidades interesadas en iniciar su proceso de acreditación como UPS",
      date: "2025-01-15",
      category: "Convocatoria",
      featured: true,
      content:
        "Las universidades interesadas en formar parte del programa de Universidades Promotoras de la Salud pueden registrarse hasta el 30 de marzo de 2025...",
    },
    {
      id: 2,
      title: "Webinar: Implementación de Entornos Saludables",
      excerpt:
        "Sesión virtual sobre estrategias para crear campus universitarios más saludables",
      date: "2025-02-20",
      category: "Evento",
      featured: false,
      content:
        "Únete a nuestro webinar gratuito donde expertos internacionales compartirán experiencias exitosas...",
    },
    {
      id: 3,
      title: "Universidad XYZ Obtiene Acreditación Avanzada",
      excerpt:
        "Reconocimiento a la excelencia en promoción de la salud universitaria",
      date: "2025-01-10",
      category: "Noticia",
      featured: true,
      content:
        "La Universidad XYZ ha logrado el nivel de Acreditación Avanzada tras un exhaustivo proceso de evaluación...",
    },
  ],

  // Contact form fields
  contactFields: [
    { name: "nombre", label: "Nombre Completo", type: "text", required: true },
    { name: "institucion", label: "Institución", type: "text", required: true },
    {
      name: "correo",
      label: "Correo Electrónico",
      type: "email",
      required: true,
    },
    { name: "telefono", label: "Teléfono", type: "tel", required: false },
    { name: "mensaje", label: "Mensaje", type: "textarea", required: true },
  ],
};
